import React, { createContext, useContext, useState, ReactNode } from "react";

type ScreenReaderContextType = {
    screenReaderMessage: string;
    setScreenReaderMessage: (message: string) => void;
};

const ScreenReaderContext = createContext<ScreenReaderContextType | undefined>(undefined);

export const ScreenReaderProvider = ({ children }: { children: ReactNode }) => {
    const [screenReaderMessage, setScreenReaderMessage] = useState("");

    return (
        <ScreenReaderContext.Provider value={{ screenReaderMessage, setScreenReaderMessage }}>
            {children}
            {/* This aria-live region allows the screen reader to read dynamic messages */}
            <div
                role="status"
                aria-live="assertive"
                aria-atomic="true"
                style={{
                    position: "absolute",
                    left: "-9999px",
                    width: "1px",
                    height: "1px",
                    overflow: "hidden",
                }}
            >
                {screenReaderMessage}
            </div>
        </ScreenReaderContext.Provider>
    );
};

export const useScreenReader = () => {
    const context = useContext(ScreenReaderContext);
    if (!context) {
        throw new Error("useScreenReader must be used within a ScreenReaderProvider");
    }
    return context;
};
